export default __webpack_public_path__ + "static/media/GARBANZO.5da8f878.png";